module.exports = function reducer_Stream(state = {}) {
    return state;
};
